import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { inputVariants, type InputProps } from './variants';

/**
 * Generic text input component with design-system variants.
 *
 * @example
 * ```tsx
 * <Input placeholder="you@example.com" inputSize="md" />
 * <Input type="password" placeholder="At least 6 characters" />
 * ```
 */
const Input = forwardRef<HTMLInputElement, InputProps>(({ className, inputSize, ...props }, ref) => (
  <input ref={ref} className={cn(inputVariants({ inputSize }), className)} {...props} />
));
Input.displayName = 'Input';

export { Input };
